import styled from "styled-components";

export const MaterialIcon = ({
  name,
  size = "md",
  color,
  weight = 400,
  fill = 0,
  grade = 0,
  className,
  ...restProps
}) => {
  return (
    <StyledIcon
      className={`material-icon icon ${className || ""}`.trim()}
      $size={size}
      $color={color}
      $weight={weight}
      $fill={fill}
      $grade={grade}
      {...restProps}
    >
      {name}
    </StyledIcon>
  );
};

const StyledIcon = styled.span`
    font-family: "Material Symbols Rounded";
    font-style: normal;
    line-height: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;

    font-size: ${({ $size, theme }) => theme.iconSize[$size] || theme.iconSize.md};

    color: ${({ $color, theme }) => $color ? theme.colors[$color] || $color : 'inherit'};

    font-variation-settings: ${({ $weight, $fill, $grade, $size, theme }) => `
        'FILL' ${$fill},
        'wght' ${$weight},
        'GRAD' ${$grade},
        'opsz' ${parseInt(theme.fontSize[$size] || theme.fontSize.md)}
    `};
`;